<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { extras } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="extras.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading colspan="2" as="th">
            {{ extras.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsPdfElementsList
            v-if="extras.list.length"
            :elements="extras.list"
            :in-two-cols-from="0"
          />

          <template v-if="extras.freeTextHeading">
            <tr>
              <td colspan="2" class="pt-3" />
            </tr>
            <tr>
              <SectionsDetailsPdfElementsHeading
                class="whitespace-pre-line"
                colspan="2"
                as="td"
              >
                {{ extras.freeTextHeading }}
              </SectionsDetailsPdfElementsHeading>
            </tr>
          </template>

          <SectionsDetailsPdfElementsFreeText
            v-if="extras.freeText.length"
            :has-border="extras.list.length > 0 && !extras.freeTextHeading"
            :free-text="extras.freeText"
          />
        </tbody>
      </table>
    </td>
  </tr>
</template>
